export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '631094d4-b65b-46e0-bed5-5af25f8c87c4';
export const MODAL_CLOSE_SEC = 2.5;

